import React, { CSSProperties, memo, useState } from 'react';
import UploadList from 'antd/es/upload/UploadList';
import { UploadFile } from 'antd/es/upload/interface';
import { message, Modal, Upload } from 'antd';
import { UploadStyle } from "./sytle"
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle
} from 'react-beautiful-dnd';
import { UploadChangeParam, UploadProps } from 'antd/lib/upload';
import { RiAddLine } from 'react-icons/ri';
import { isFileOversized, isImage, isImageResolutionTooLarge } from 'utils/functions/file';

const grid = 8;
const getListStyle = (isDraggingOver: boolean): CSSProperties => ({
  background: isDraggingOver ? 'lightblue' : '#f9f9f9',
  display: 'flex',
  flexWrap: 'wrap',
  padding: grid * 2,
  overflow: 'auto',
});
const getItemStyle = (isDragging: boolean, draggableStyle: DraggingStyle | NotDraggingStyle | undefined): CSSProperties => ({
  userSelect: 'none',
  padding: 0,
  margin: 4,
  height: 104,
  width: 104,
  background: isDragging ? 'lightgreen' : '#f9f9f9',
  ...draggableStyle,
});
type Props = {
  disabled?: boolean
  value?: UploadFile[]
  onChange?: (params: UploadFile[]) => void
  maxLength?: number
} & UploadProps
const PicturesWall: React.FC<Props> = memo(({ onChange: onFileChange, ...props }) => {
  const [previewImage, setPreviewImage] = useState('');
  const fileList = props.value || [];

  const onChange = async ({ fileList }: UploadChangeParam) => {

    let innerError = 0
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i].originFileObj;
      if(file && !isImage(file)){
        innerError =1
        break
      }
      if(file && isFileOversized(file,20)){
        innerError =2
        break
      }
      if(file &&  await isImageResolutionTooLarge(file, 7680 , 7680)) {
        innerError =3
        break
      }
    }

    switch (innerError) {
      case 1:
        message.warning('上传文件中包含不支持的图片格式,请检查后重新上传',2);
        break;
        case 2:
          message.warning('上传文件中包含尺寸超出20M文件,请检查后重新上传',2);
          break;
          case 3:
            message.warning('包含超大分辨率图片,请检查后重新上传',2);
            break;
    }

  if(innerError===0){
    onFileChange!(fileList);
  }
    // onFileChange!(fileList);
  };

  const onRemove = (file: UploadFile) => {
    if (props.disabled) {
      return false
    }
    const newFileList = fileList.filter(
      (item) => item.uid !== file.uid
    );
    onFileChange!(newFileList);
  };

  const reorder = (list: UploadFile[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = ({ source, destination }: DropResult) => {
    if (!destination) {
      return;
    }

    const newFileList = reorder(
      fileList,
      source.index,
      destination.index
    );
    onFileChange!(newFileList);
  };
  const getBase64 = (file: File | Blob | undefined): Promise<string> => {
    if (!file) return Promise.reject(new Error('no file'));
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file!);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const imagePreview = async (file: UploadFile, callback: (params: { image: string }) => void) => {
    const newFile = file;
    if (!newFile.url && !newFile.preview) {
      newFile.preview = await getBase64(file.originFileObj);
    }

    const newPreviewImage: string = newFile.url || newFile.preview || '';
    callback({
      image: newPreviewImage,
    });
  };

  const onPreview = async (file: UploadFile) => {
    await imagePreview(file, ({ image }) => {
      setPreviewImage(image);
    });
  };
  const beforeUpload = () => {

    return false
  }
  const uploadButton = (
    <div>
      <RiAddLine />
      <div>上传</div>
    </div>
  );

  return (
    <UploadStyle>
      {fileList && (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" direction='horizontal'>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={getListStyle(snapshot.isDraggingOver)}
                className='drop-wrap'
              >
                {fileList.map((item, index) => (
                  <Draggable
                    key={item.uid}
                    draggableId={item.uid}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                        className='drop'
                      >
                        <UploadList
                          locale={{ previewFile: '预览图片', removeFile: '删除图片' }}
                          showDownloadIcon={false}
                          listType={props.listType}
                          onPreview={onPreview}
                          onRemove={onRemove}
                          showRemoveIcon={!props.disabled}
                          items={[item]}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {fileList.length < (props.maxLength || 5) && !props.disabled && <Upload
                  {...props}
                  disabled={props.disabled}
                  fileList={fileList}
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={onChange}
                  multiple={true}
                  maxCount={props.maxLength || 5}
                >
                  {uploadButton}
                </Upload>
                }
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
      <Modal
        open={!!previewImage}
        footer={null}
        onCancel={() => setPreviewImage('')}
        bodyStyle={{ padding: 0 }}
      >
        <img style={{ width: '100%' }} alt="" src={previewImage} />
      </Modal>
    </UploadStyle>
  );
});

export { PicturesWall };
